<div class="ui footer container" [ngClass]="class">
    <p class="text-right">
        <span class="greytext">Все права защищены. &copy; 2017-2020 ЗаРента</span>
    </p>
</div>
